/**
 * Global Cart Service
 * Holds the current state of the cart
 * handles updating quantity and removing items
 **/

import { ajax } from "../utils/index";
import eventBus from "./event-bus";

const CartService = function () {
  let $this = {};

  $this.currentProduct = false;
  $this.productAdded = false;

  $this.init = function () {
    $this.getCart();
    eventBus.on(eventBus.types.AddingToCart, $this.AddingToCart);
    eventBus.on(eventBus.types.AddedToCart, $this.addedToCart);
  };
  $this.AddingToCart = function ($data) {
    $this.currentProduct = $data.detail;
  };

  $this.addedToCart = function ($data) {
    $this.productAdded = $data;
    $this.getCart();
  };

  $this.getCart = function () {
    ajax("GET", "/cart.json").then((res) => {
      res = JSON.parse(res);
      res = JSON.parse(res.response);
      $this.cart = res;
      eventBus.dispatch(eventBus.types.CartUpdated, $this.cart);
    });
  };

  $this.removeItem = function (key) {
    const $promise = new Promise(function (resolve, reject) {
      ajax("POST", "/cart/change.js", { quantity: 0, id: key }).then(function (
        res
      ) {
        let jsonResponse = JSON.parse(res);
        let jsonData = JSON.parse(jsonResponse.response);

        $this.cart = jsonData;
        resolve({ cart: $this.cart, success: true });
        eventBus.dispatch(eventBus.RemovedFromCart, {
          cart: $this.cart,
          key: key,
        });
        eventBus.dispatch(eventBus.types.CartUpdated, $this.cart);
      });
    });
    return $promise;
  };

  $this.removeItems = async (keys) => {
    const results = []

    for ( const key of keys ) {
      try {
        const result = await new Promise((resolve, reject) => {
          ajax(
            'POST',
            '/cart/change.js',
            { quantity: 0, id: key }
          ).then(res => {
            let response = JSON.parse(res)
            let data = JSON.parse(response.response)

            $this.cart = data
            eventBus.dispatch(eventBus.types.RemovedFromCart, {
              cart: $this.cart,
              key: key,
            })

            resolve({ cart: data, success: true })
          }, (error) => {
            reject(error)
          })
        })

        results.push(result)
      } catch (err) {
        console.error('Failed to remove an item from the cart: CartService.removeItemArray', err)
      }
    }

    if (results.every(result => result.success)) {
      $this.cart = results[results.length - 1].cart;
      eventBus.dispatch(eventBus.types.CartUpdated, $this.cart);
    } else {
      const error = new Error('One or more items could not be removed from the cart.');
      console.error(error);
      throw error;
    }

    return results
  }

  $this.updateQuantity = function (key, value, line ) {
    const $promise = new Promise(function (resolve, reject) {
      const data = { quantity: value, id: key };
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((response) => {
          response.json().then((json) => {
            $this.cart = json;
            resolve({ cart: $this.cart, success: true });
            eventBus.dispatch(eventBus.types.CartUpdated, $this.cart);
          });
        })
        .catch((error) => {
          alert("There was an error updating the quantity ");
          reject();
        });
    });
    return $promise;
  };

  $this.updateQuantity__update = function (updates) {
    const $promise = new Promise(function (resolve, reject) {
      const data = { updates: updates };
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((response) => {
          response.json().then((json) => {
            $this.cart = json;
            resolve({ cart: $this.cart, success: true });
            eventBus.dispatch(eventBus.types.CartUpdated, $this.cart);
          });
        })
        .catch((error) => {
          alert("There was an error updating the quantity ");
          reject();
        });
    });
    return $promise;
  };

  $this.getCartItemByUID = function (uid) {
    if( ! $this.cart || ! $this.cart.items ) { 
      return false;
    }

    const item = $this.cart.items.find(item => item.properties._uid === uid);

    if( item ) {
      return item;
    }else{
      console.log( uid  + ' not found in cart' )
      return false;
    }
  }

  return $this;
};

export default CartService;
